/**
 * @author Ahmed Serag
 * @date 2020-07-21
 * @description declaration of available Error messages in the app.
 * @filename errors.ts
 */

/**
 * set of available errors in the App.
 */
export const ERRORS = {
  validation: "Please make sure you are adding valid values.",
  unexpected: "Unexpected Error, please contact support.",
  noNetwork: "No Network connection. Please try again later.",
  createUser: {
    codeAlreadySent: 400,
  },
};
